/* Produktgalerie: Mini-Vorschau links und rechts (nur Desktop) + Automatiklauf.

   Welches Bild gerade gross zu sehen ist, wird aus dem Zaehler des Themes
   gelesen ("2 / 5"). Das ist die einzige Quelle, die auch im Endlosbetrieb
   stimmt — der Slider ordnet seine Slides beim Scrollen um, eigene Messungen
   der Scrollposition liefen deshalb aus dem Tritt.

   Die Vorschauen rechnen im Kreis: vor dem ersten Bild steht das letzte, nach
   dem letzten das erste. Ein Klick loest den vorhandenen Pfeil aus, damit
   Zaehler, Punkte und Endlos-Logik des Themes sauber mitlaufen.

   Platz: das Bild-Element fuellt den ganzen Rahmen, das sichtbare Motiv ist
   wegen object-fit: contain aber schmaler. Die freie Breite ergibt sich
   deshalb aus dem Seitenverhaeltnis des Motivs (naturalWidth/naturalHeight).
   Weil die Bildhoehe an die Fensterhoehe gekoppelt ist (70 dvh), aendert sich
   der freie Streifen mit jeder Fenstergroesse — deshalb wird bei resize neu
   gerechnet.

   Von dem Streifen geht die Pfeilflaeche ab. Die Vorschau passt sich in der
   Groesse an, was uebrig bleibt (46 bis 140 px), und verschwindet erst, wenn
   auch dafuer kein Platz mehr ist. Ueberdeckt wird dabei weder Pfeil noch
   Motiv. */
(function () {
  var TAKT = 4000;
  var RUHE = 3;
  var MIN_BREITE = 46;
  var MAX_BREITE = 140;
  var LUFT = 8;             // Abstand zum Pfeil und zum Motiv

  function klein(url) {
    if (!url) return '';
    if (url.indexOf('width=') > -1) return url.replace(/width=\d+/, 'width=400');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('slideshow-component'), function (sc) {
      if (sc.dataset.rvBereit) return;

      var slides = sc.querySelectorAll('slideshow-slide.product-media-container');
      var scroller = sc.querySelector('slideshow-slides');
      var container = sc.querySelector('slideshow-container');
      var weiter = sc.querySelector('.slideshow-control--next');
      var zurueck = sc.querySelector('.slideshow-control--previous');
      if (slides.length < 2 || !scroller || !container) return;

      sc.dataset.rvBereit = '1';
      var anzahl = slides.length;

      function index() {
        var z = sc.querySelector('.slideshow-controls__counter');
        var n = z ? parseInt(z.textContent.trim(), 10) : NaN;
        return isNaN(n) ? 0 : n - 1;
      }

      /* ---------- Mini-Vorschauen ---------- */

      if (anzahl >= 3 && weiter && zurueck) {
        var bauen = function (seite, knopf) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rv-vorschau rv-vorschau--' + seite;
          b.setAttribute('aria-label', knopf.getAttribute('aria-label') || '');
          var img = document.createElement('img');
          img.alt = '';
          img.decoding = 'async';
          b.appendChild(img);
          b.addEventListener('click', function () { knopf.click(); });
          container.appendChild(b);
          return b;
        };

        var vor = bauen('vor', zurueck);
        var nach = bauen('nach', weiter);

        var quellen = Array.prototype.map.call(slides, function (s) {
          var i = s.querySelector('img');
          return i ? klein(i.currentSrc || i.src) : '';
        });

        quellen.forEach(function (u) { if (u) { var v = new Image(); v.src = u; } });

        var setzen = function (knopf, url) {
          var img = knopf.querySelector('img');
          if (!url || img.getAttribute('src') === url) return;
          knopf.classList.add('rv-wechsel');
          setTimeout(function () {
            img.setAttribute('src', url);
            knopf.classList.remove('rv-wechsel');
          }, 130);
        };

        var messen = function () {
          var cr = container.getBoundingClientRect();
          var bild = slides[0].querySelector('img');
          if (!bild || !cr.width) return;

          var br = bild.getBoundingClientRect();
          var sichtbar = br.width;
          if (window.getComputedStyle(bild).objectFit === 'contain'
              && bild.naturalWidth && bild.naturalHeight) {
            sichtbar = Math.min(br.width, br.height * (bild.naturalWidth / bild.naturalHeight));
          }

          var streifen = (cr.width - sichtbar) / 2;
          var pfeil = zurueck.getBoundingClientRect().width || 44;
          var zone = streifen - pfeil - LUFT * 2;
          var breite = Math.min(zone, MAX_BREITE);
          var zeigen = window.innerWidth >= 750 && breite >= MIN_BREITE;

          container.classList.toggle('rv-hat-vorschau', zeigen);
          vor.hidden = !zeigen;
          nach.hidden = !zeigen;
          if (!zeigen) return;

          var abstand = pfeil + LUFT + (zone - breite) / 2;

          [vor, nach].forEach(function (k) {
            k.style.width = Math.round(breite) + 'px';
            k.style.height = Math.round(breite * 1.25) + 'px';
          });
          vor.style.left = Math.round(abstand) + 'px';
          nach.style.right = Math.round(abstand) + 'px';
        };

        var auffrischen = function () {
          var i = index();
          setzen(vor, quellen[(i - 1 + anzahl) % anzahl]);
          setzen(nach, quellen[(i + 1) % anzahl]);
        };

        vor.querySelector('img').setAttribute('src', quellen[anzahl - 1]);
        nach.querySelector('img').setAttribute('src', quellen[1]);
        messen();

        var zaehler = sc.querySelector('.slideshow-controls__counter');
        if (zaehler && window.MutationObserver) {
          new MutationObserver(auffrischen).observe(zaehler, {
            childList: true, characterData: true, subtree: true
          });
        }
        scroller.addEventListener('scrollend', auffrischen);
        window.addEventListener('resize', messen);
        window.addEventListener('load', function () { messen(); auffrischen(); });
        setTimeout(function () { messen(); auffrischen(); }, 500);
        setTimeout(messen, 1600);
        setTimeout(messen, 3000);
      }

      /* ---------- Automatiklauf ---------- */

      if (!weiter) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var pause = false;
      var ruhe = 0;

      sc.addEventListener('mouseenter', function () { pause = true; });
      sc.addEventListener('mouseleave', function () { pause = false; });
      sc.addEventListener('focusin', function () { ruhe = RUHE; });
      sc.addEventListener('pointerdown', function () { ruhe = RUHE; });
      scroller.addEventListener('touchstart', function () { ruhe = RUHE; }, { passive: true });
      scroller.addEventListener('wheel', function () { ruhe = RUHE; }, { passive: true });

      setInterval(function () {
        if (pause || document.hidden) return;
        if (document.querySelector('dialog[open]')) return;
        if (ruhe > 0) { ruhe--; return; }

        var vorher = index();
        weiter.click();

        setTimeout(function () {
          if (index() !== vorher || vorher !== anzahl - 1) return;
          var punkte = sc.querySelectorAll('.slideshow-controls__dots button');
          if (punkte.length) punkte[0].click();
        }, 800);
      }, TAKT);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
